<!-- SRD Tooltip Template -->
<ng-template #srdTooltipTemplate>
    <div [innerHTML]="constants.STOCK_REQUIRED_DATE_TOOLTIP"></div>
</ng-template>

<div class="product-details-wrap">
    @if (isPreview && isShowTitle) {
        <div class="product-details-head">
            <h2>Product Detail</h2>
        </div>
    } @else {
        @if (!isPreview || isDespatchDetail || isShowTitle) {
            <div class="product-details-head">
                <h2>Product Detail</h2>
                @if (!isDespatchDetail && !isOfflineOrder && !isOrderDeliveryStage()) {
                    <button class="btn" (click)="toggleAddItemSideBar($event)">Add Item</button>
                }
            </div>
        }
    }

    <div class="product-details-table" [ngClass]="{'sticky-header-enabled': isStickyHeader, 'split-delivery-table': modelOrder?.is_split_delivery}">
        <table>
            <thead>
            <tr>
                <th>
                    #
                </th>
                <th class="product-desc-th">
                    Product Description
                </th>
                @if (modelOrder?.is_split_delivery) {
                    <th>
                        <span>Stock Req. Date <small>(SRD)</small></span>
                        <img src="/assets/admin/images/info-circle-icon.svg"
                             width="16"
                             height="16"
                             alt="info-icon"
                             class="cursor-pointer ms-1"
                             [tooltip]="srdTooltipTemplate"
                             contentType="template"
                             container="body"
                             placement="auto"/>
                    </th>
                }
                @if (modelOrder?.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
                    <th>
                        Lead Time
                    </th>
                } @else {
                    <th></th>
                }
                @if ((modelOrder?.is_split_delivery || modelOrder?.is_split_production) && isOrderDetail) {
                    <th>Status</th>
                }
                @if (modelOrder?.is_split_production && isOrderDetail) {
                    <th>ETA</th>
                }
                <th>
                    Qty
                </th>
                <th class="text-right">
                    <span>RRP</span>
                    <small>(Ex. GST)</small>
                </th>
                <th class="text-right">
                    <span>Trade Price</span>
                    <span class="off-label">{{
                            getFormattedDiscount(modelOrder?.quote_summary?.trade_discount_percentage) + "OFF"
                        }}</span>
                    <small>(Ex. GST)</small>
                </th>
                <th class="text-right">
                    <span>Additional<br/> Discount <small>(%)</small></span>
                </th>
                <th class="text-right">
                    <span>Disc. Price</span>
                    <small>(Ex. GST)</small>
                </th>
                <th class="text-right">
                    <span>Final Total</span>
                    <small>(Ex. GST)</small>
                </th>
                <th class="action-th pro-table-action display-table-cell">
                    <!--          Action-->
                    @if (!isOrderCancel && !isQuoteCancel) {
                        <button type="button" class="btn" [tooltip]="'Click to open/close all existing comments'"
                                [placement]="'left'" container="body" containerClass="comment-tooltip"
                                [class.added-comment]="containsComment" (click)="displayAllComments()">
                            <img src="/assets/admin/images/comment-icon.svg" width="22" height="22" class="comment-icon"
                                 alt="comment-icon">
                            <img src="/assets/admin/images/comment-fill-icon.svg" width="22" height="22"
                                 class="comment-fill-icon" alt="comment-fill-icon">
                        </button>
                    }
                </th>
            </tr>
            </thead>
            @if (modelOrder?.quote_product && modelOrder?.quote_product.length > 0) {
                <ng-container
                    *ngFor="let productsRow of modelOrder?.quote_product;let i = index; trackBy: trackByProductId">
                    <tbody dndSortable [dndList]="modelOrder?.quote_product"
                           [ngClass]="{'dropped-zone': productsRow.order_index == hoveredProductIndex && productsRow.order_index !== draggedProductIndex, 'dragged-item': productsRow.order_index === draggedProductIndex}"
                           dndDropzone [dndObject]="productsRow" (dndDrop)="onProductRowDrop($event, productsRow)"
                           [dndDraggable]="productsRow" [dndEffectAllowed]="'move'"
                           (dndStart)="onProductRowDragStart(productsRow)" (dndEnd)="onProductRowDragEnd()"
                           (dndDragover)="onProductRowDragOver($event, productsRow)">
                    <tr>
                        <td>
                            <div class="pro-no">{{ productsRow.displayIndex }}</div>
                        </td>
                        <td>
                            <div class="table-pro-info-box">
                                <div class="table-pro-info-img">
                                    @if (!productsRow?.product?.is_custom_product) {
                                        <img src="{{ productImage(productsRow) }}" alt=""
                                             (error)="helperFunction.getErrorImage($event)" width="70" height="70"/>
                                    } @else {
                                        <img src="{{ Constants.NO_IMAGE_PRODUCT }}" alt=""
                                             (error)="helperFunction.getErrorImage($event)" width="70" height="70"/>
                                    }
                                </div>
                                <div class="table-pro-info">
                                    <h3>
                                        <!--
                                          is_auto_created is treated exactly like a Custom Product here.
                                          A product that arrived on an offline order without being in the MASTER SKU
                                          SHEET has NO catalogue attributes at all — no family, collection, category,
                                          finish or dimensions — because every one of those comes from the sheet. It is
                                          deliberately NOT flagged as a Custom Product, so it fell through to the family
                                          branch below and rendered an EMPTY heading with a bare "—" beneath it.
                                          Custom Products are the existing answer to "not in the sheet", so these follow
                                          the same one rather than a third style of their own. Catalogue products always
                                          have a family and are unaffected.
                                        -->
                                        @if (productsRow?.product?.is_custom_product || productsRow?.product?.is_auto_created) {
                                            {{ productsRow?.product?.sku }}
                                        } @else if (productsRow?.consumables_prices?.sku_code) {
                                            {{ productsRow?.consumables_prices?.sku_code }}
                                        } @else {
                                            {{ productsRow?.product?.family?.name }}
                                        }

                                        @if (shouldShowPriceUpdateWarning(productsRow) &&
                                        !isPriceWarningDismissed(productsRow.id)) {
                                            <i class="fa fa-exclamation-triangle price-update-warning-icon"
                                               aria-hidden="true"
                                               [tooltip]="'Please note that rates applied to the original version of this line item have changed. Consultation with your client may be necessary.'"></i>
                                        }

                                        <!-- Custom Products are not part of the Master SKU list, so the Master SKU import
                                             soft-deletes them on every run. is_deleted therefore says nothing about them and
                                             they must never read as discontinued.
                                             The blanket SQ/SO suppression that used to sit here (e3ead4c61, "Discontinued
                                             batch should not be appear for SQ and SO") was a workaround for exactly that
                                             false positive; the is_custom_product test above replaces it, so a genuinely
                                             discontinued Master SKU product now shows the badge on SQ/SO records too. -->
                                        @if (productsRow?.product?.is_deleted && !productsRow?.product?.is_custom_product) {
                                            <span class="status product-discontinued-status pulse-effect"
                                                  [tooltip]="discontinuedTooltip">Discontinued</span>
                                            <ng-template #discontinuedTooltip>
                                                <div class="pro-info-tooltip">
                                                    <p><strong>Product Discontinued.</strong></p>
                                                    <p>To proceed with order, kindly remove this item from your
                                                        quote/order.</p>
                                                </div>
                                            </ng-template>
                                        }

                                        <!-- Task notification with bullhorn icon and count badge -->
                                        @if (productsRow.productLevelTasks && productsRow.productLevelTasks.length > 0) {
                                            <span class="followup-flag task-notification-icon"
                                                  [ngClass]="{'active': productsRow.isTasksExpanded}"
                                                  (click)="toggleTasksIcon(productsRow)" [tooltip]="'Product Tasks'"
                                                  placement="bottom" container="body">
                                            <i class="fa fa-bullhorn"></i>
                                            <span
                                                style="padding-left: 5px;">{{ productsRow.productLevelTasks.length ? productsRow.productLevelTasks.length : '' }}</span>
                                        </span>
                                        } @else if (productsRow.task && productsRow.task.length > 0) {
                                            <!-- Legacy task display (for backwards compatibility) -->
                                            <span *ngIf="taskHasCategory(productsRow.task)" class="followup-flag"
                                                  [tooltip]="followupTooltip">
                                            <i class="fa fa-bullhorn"></i>
                                        </span>
                                            <ng-template #followupTooltip>
                                                <div *ngFor="let task of productsRow.task; let last = last">
                                                    <div class="pro-info-tooltip" *ngIf="task.task_category != null">
                                                        <p><strong>{{ task.task_category.title }}
                                                            ({{ task.task_number }}
                                                            ):</strong> {{ task.task_category.action }}</p>
                                                        <p><strong>Assigned admin</strong>: {{
                                                                task.assigned_to ? task.backend_user?.first_name + ' ' +
                                                                    task.backend_user?.last_name : '-'
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        }

                                        <!-- REMOVED: Product-level task badges - Now shown in collapsible section below -->
                                        <!--
                                        <ng-container
                                            *ngIf="productsRow.productLevelTasks && productsRow.productLevelTasks.length > 0">
                                            <span *ngFor="let task of productsRow.productLevelTasks"
                                                  class="follow-up-label product-task-badge"
                                                  [style.background]="task.task_category?.colour"
                                                  [tooltip]="productTaskTooltip"
                                                  placement="bottom"
                                                  (click)="onProductTaskClick(task, productsRow)"
                                                  style="cursor: pointer; margin-left: 5px;">
                                                {{ task.task_category?.title }}
                                            </span>
                                            <ng-template #productTaskTooltip>
                                                <div
                                                    *ngFor="let task of productsRow.productLevelTasks; let last = last">
                                                    <p [style.margin-bottom]="last ? '0' : '10px'">
                                                        <strong> {{ task.task_number }}
                                                            : </strong>{{ task.task_category?.action }} <br/>
                                                        <strong>Assigned admin</strong>:
                                                        {{ task.backend_user ? task.backend_user.first_name + " " + task.backend_user.last_name : "—" }}
                                                    </p>
                                                </div>
                                            </ng-template>
                                        </ng-container>
                                        -->

                                        @if (!productsRow?.consumables_prices && !isPreview && modelOrder?.type ==
                                        constants.ORDER_TYPE_ORDER_SHORT && !productsRow.stock_available &&
                                        !productsRow.container_id) {
                                            <span class="stock-allocation-required-flag followup-flag"
                                                  tooltip="Stock Allocation Required"
                                                  (click)="toggleStockIcon(productsRow)">
                                            <img src="/assets/admin/images/stock-icon.svg" width="20" height="22"
                                                 alt="stock-icon"/>
                                        </span>
                                        }

                                        @if (productsRow?.product?.is_custom_product) {
                                            <img src="/assets/admin/images/copy-icon.svg" width="15" height="15"
                                                 alt="copy-icon" [tooltip]="'Copy'"
                                                 (click)="copySku(productsRow?.product?.sku);$event.preventDefault()"/>
                                        }

                                        @if (productsRow?.consumables_prices?.sku_code) {
                                            <img src="/assets/admin/images/copy-icon.svg" width="15" height="15"
                                                 alt="copy-icon" [tooltip]="'Copy'"
                                                 (click)="copySku(productsRow?.consumables_prices?.sku_code);$event.preventDefault()"/>
                                        }
                                    </h3>

                                    <!-- Collapsible task badges (appear between product name and description) -->
                                    @if (productsRow.productLevelTasks && productsRow.productLevelTasks.length > 0 &&
                                    productsRow.isTasksExpanded) {
                                        <div class="followup-bedges product-task-badges-container"
                                             [ngbCollapse]="!productsRow.isTasksExpanded">
                                        <ng-container *ngFor="let task of productsRow.productLevelTasks">
                                        <span class="rescheduled-note-wrap">
                                        <span class="follow-up-label"
                                              [style.background]="(task | isRescheduledTask) ? '#ff7600' : task.task_category?.colour"
                                              [tooltip]="taskDetailTooltip" placement="bottom" container="body"
                                              (click)="onProductTaskClick(task, productsRow)">
                                            {{ task.task_category?.title }}
                                        </span>
                                        <span *ngIf="task?.note" class="rescheduled-note-flag"
                                              [tooltip]="task.note" [tooltipClass]="'custom-tooltip-class'" container="body"
                                              placement="bottom" (click)="$event.stopPropagation()">
                                          <i class="far fa-comment"></i>
                                        </span>
                                        </span>
                                        </ng-container>
                                            <ng-template #taskDetailTooltip>
                                                <div
                                                    *ngFor="let task of productsRow.productLevelTasks; let last = last">
                                                    <p [style.margin-bottom]="last ? '0' : '10px'">
                                                        <strong>{{ task.task_number }}: </strong>{{
                                                            task.task_category?.action
                                                        }}<br/>
                                                        <strong>Assigned admin</strong>: {{
                                                            task.backend_user ?
                                                                task.backend_user.first_name + " " + task.backend_user.last_name :
                                                                "-"
                                                        }}
                                                    </p>
                                                </div>
                                            </ng-template>
                                        </div>
                                    }

                                    <!-- Product description details (always visible) -->
                                    <!-- Same reasoning as the heading above: the Unleashed description is the only
                                         description such a product has, and is the text Unleashed itself shows. -->
                                    @if (productsRow?.product?.is_custom_product || productsRow?.product?.is_auto_created) {
                                        <p>
                                            {{ productsRow?.product?.ul_product_description || "-" }}
                                        </p>
                                    } @else if (productsRow?.consumables_prices?.description) {
                                        <p>
                                            {{ productsRow?.consumables_prices?.description || "-" }}
                                        </p>
                                    } @else {
                                        <p *ngIf="productsRow.product?.type == constants.SURFACE_SORT_NAME">
                                            {{
                                                productsRow?.product?.join_product_type_collection_category[0]?.product_collection?.name
                                            }}{{
                                                productsRow?.product?.join_product_type_collection_category[0]?.product_category?.name
                                                    ? " - " +
                                                    productsRow?.product?.join_product_type_collection_category[0]?.product_category?.name
                                                    : ''
                                            }}
                                        </p>
                                        <p *ngIf="productsRow?.product?.type == constants.PRODUCT_TYPE_SURFACE_ACCESSORY">
                                            {{ productsRow?.product | accessoryName }}
                                        </p>
                                        <p>
                                            {{ productsRow?.product?.finish?.name || "-" }}
                                        </p>
                                        <p>
                                            {{ productsRow?.product ? getSizingDimensions(productsRow?.product) : '-' }}
                                        </p>
                                    }

                                    <div class="table-pro-no">
                                        @if (!productsRow?.product?.is_custom_product && !productsRow?.consumable_id) {
                                            <a [routerLink]="['/products/' + productsRow?.product.id + '/' + productsRow?.product.type]"
                                               [ngbPopover]="orderDetail" [autoClose]="true" [placement]="'top'"
                                               triggers="mouseenter:mouseleave" #od="ngbPopover"
                                               (shown)="onWarehousePopoverShown(productsRow)"
                                               popoverClass="warehouse-info">
                                                {{ productsRow.product?.sku }}
                                                <ng-template #orderDetail>
                                                    <div class="warehouse-pro-name">{{ productsRow.product?.sku }}</div>
                                                    <div class="warehouse-short-des">{{
                                                            productsRow.product?.ul_product_description
                                                        }}
                                                    </div>
                                                    <div class="warehouse-title">Main Warehouse</div>
                                                    @if (productsRow?.product?.is_assembled_product) {
                                                        <!--
                                                          An assembled product has no stock of its own to show, so this
                                                          shows what its Stock On Hand card shows: Unleashed's Can
                                                          Assemble as Available, the orders allocated to Stock On Hand
                                                          here, and the two together as Total.
                                                        -->
                                                        <ul>
                                                            @if (productsRow?.product?.assembledShelf) {
                                                                <li>
                                                                    Total Qty
                                                                    <strong>{{ productsRow.product.assembledShelf.total_qty | number: '1.0-2' }}</strong>
                                                                </li>
                                                                <li>
                                                                    Allocated Qty
                                                                    <strong>{{ productsRow.product.assembledShelf.allocated_qty | number: '1.0-2' }}</strong>
                                                                </li>
                                                                <li>
                                                                    Available Qty
                                                                    <strong>{{ productsRow.product.assembledShelf.available_qty | number: '1.0-2' }}</strong>
                                                                </li>
                                                                @if (productsRow.product.assembledShelf.short_by > 0) {
                                                                    <li>
                                                                        Short by
                                                                        <strong>{{ productsRow.product.assembledShelf.short_by | number: '1.0-2' }}</strong>
                                                                    </li>
                                                                }
                                                                <!-- Unleashed's own figure, for reference only. -->
                                                                @if (productsRow.product.assembledShelf.can_assemble !== null) {
                                                                    <li>
                                                                        Unleashed Can Assemble
                                                                        <strong>{{ productsRow.product.assembledShelf.can_assemble | number: '1.0-2' }}</strong>
                                                                    </li>
                                                                }
                                                            } @else {
                                                                <li>Loading…</li>
                                                            }
                                                            <li>
                                                                On Purchase
                                                                <strong>
                                                                    {{
                                                                        productsRow.product?.ul_on_purchase ?
                                                                            productsRow.product?.ul_on_purchase : 0
                                                                    }}
                                                                </strong>
                                                            </li>
                                                        </ul>
                                                    } @else {
                                                    <ul>
                                                        <li>
                                                            Stock On Hand
                                                            <strong>
                                                                {{
                                                                    productsRow.product?.ul_stock_on_hand ?
                                                                        productsRow.product?.ul_stock_on_hand : 0
                                                                }}
                                                            </strong>
                                                        </li>
                                                        <li>
                                                            Allocated Qty
                                                            <strong>
                                                                {{
                                                                    productsRow.product?.ul_allocated_qty ?
                                                                        productsRow.product?.ul_allocated_qty : 0
                                                                }}
                                                            </strong>
                                                        </li>
                                                        <li>
                                                            Available Qty
                                                            <strong>
                                                                {{
                                                                    productsRow.product?.ul_available_qty ?
                                                                        productsRow.product?.ul_available_qty : 0
                                                                }}
                                                            </strong>
                                                        </li>
                                                        <li>
                                                            On Purchase
                                                            <strong>
                                                                {{
                                                                    productsRow.product?.ul_on_purchase ?
                                                                        productsRow.product?.ul_on_purchase : 0
                                                                }}
                                                            </strong>
                                                        </li>
                                                    </ul>
                                                    }
                                                </ng-template>
                                            </a>
                                        }

                                        @if (!productsRow?.product?.is_custom_product && !productsRow?.consumable_id) {
                                            <img src="/assets/admin/images/copy-icon.svg" width="12" height="13"
                                                 alt="copy-icon" [tooltip]="'Copy'"
                                                 (click)="copySku(productsRow.product?.sku);$event.preventDefault()"/>
                                        }
                                    </div>

                                </div>
                            </div>
                        </td>
                        @if (modelOrder?.is_split_delivery) {
                            <td class="stock-required-date-td">
                                <ng-template #HtmlContent>
                                    <div class="stock-req-tooltip" [innerHTML]="getSRDTooltip(productsRow)"></div>
                                </ng-template>
                                <ng-template #HtmlContent1 let-tooltip="tooltip">
                                    @if (tooltip) {
                                        <div class="stock-req-tooltip">
                                            @if (tooltip.user_profile) {
                                                <img
                                                    [src]="s3BucketProfileURL + '/' + tooltip?.user_profile + constants.IMAGE_SIZE_165_X_165"
                                                    (error)="helperFunction.getErrorImage($event)" height="50"
                                                    width="50"/>
                                            } @else {
                                                <img [src]="noImage" alt="No Image" height="50" width="50"/>
                                            }
                                            <div class="stock-req-info">
                                                <h3>{{ tooltip.user_name }}</h3>
                                                <p>Changed at: <strong>{{ tooltip.change_at }}</strong></p>
                                            </div>
                                        </div>
                                    }
                                </ng-template>

                                <div class="stock-required-date">
                                <span
                                    [ngbTooltip]="(productsRow?.quote_schedule_delivery_product?.quote_schedule_delivery | srdActivityInfo : productsRow?.product_id) ? HtmlContent1 : null"
                                    [tooltipContext]="{ tooltip: (productsRow?.quote_schedule_delivery_product?.quote_schedule_delivery | srdActivityInfo : productsRow?.product_id) }"
                                    [tooltipClass]="'stockReq-tooltip'" placement="top">
                                    {{
                                        productsRow?.quote_schedule_delivery_product?.stock_required_date ?
                                            (productsRow.quote_schedule_delivery_product.stock_required_date | date :
                                                'dd/MM/yyyy') : '-'
                                    }}
                                    @if (productsRow?.quote_schedule_delivery_product?.quote_schedule_delivery?.delivery_code) {
                                        <span class="delivery-code-label d-block text-center">
                                        {{
                                                getDeliveryCodeSuffix(productsRow?.quote_schedule_delivery_product?.quote_schedule_delivery?.delivery_code)
                                            }}
                                    </span>
                                    }
                                </span>
                                    @if (!isDespatchDetail) {
                                        <div class="stock-date-icon"
                                             [tooltip]="getSRDTooltip(productsRow) ? HtmlContent : null"
                                             (click)="updateStockRequiredDate(productsRow.id, productsRow?.quote_schedule_delivery_product, false, productsRow?.quote_schedule_delivery_product?.quote_schedule_delivery?.id, productsRow?.status_quote_product)"
                                             [class.red-bg]="(productsRow?.quote_schedule_delivery_product?.stock_required_date == null || productsRow?.quote_schedule_delivery_product?.stock_required_date == '') || productsRow.isDisplayPulsingEffect"
                                             [class.orange-bg]="productsRow?.quote_schedule_delivery_product?.stock_required_date != null && productsRow?.quote_schedule_delivery_product?.stock_required_date != '' && !productsRow.isDisplayPulsingEffect"
                                             [class.pulsing-effect]="productsRow.isDisplayPulsingEffect">
                                            <img src="/assets/admin/images/calendar-white-icon.svg" width="18"
                                                 height="20"
                                                 alt="calendar-white-icon"/>
                                        </div>
                                    }
                                </div>
                            </td>
                        }
                        @if (modelOrder?.type === Constants.ORDER_TYPE_QUOTE_SHORT) {
                            <td>
                                @if (productsRow?.consumable_id && !productsRow?.product_id) {
                                    <!-- A standalone consumable is stock on the shelf, so it is always
                                         "In Stock". Without this it fell through to the product's own
                                         calculatedLeadTime, which a consumable line has no product to
                                         carry — leaving the cell blank. -->
                                    {{ constants.LEAD_TIME_IN_STOCK }}
                                } @else if (productsRow?.product?.calculatedLeadTime == 'TBC') {
                                    <span class="lead-time-tbc">
                                TBC <img src="/assets/admin/images/info-circle-icon.svg" width="20" height="20"
                                         alt="info-icon" class="info-icon" [tooltip]="constants.LEAD_TIME_TBC_TOOLTIP"/>
                            </span>
                                } @else {
                                    {{ productsRow?.product?.calculatedLeadTime | productLeadTime }}
                                }
                            </td>
                        } @else {
                            <td></td>
                        }

                        @if ((modelOrder?.is_split_delivery || modelOrder?.is_split_production) && isOrderDetail) {
                            <td>
                                @if (productsRow.status_quote_product) {
                                    <span [class]="toKebabCase(productsRow.status_quote_product?.name)"
                                          class="status-flag"
                                          [ngClass]="{'mb-2': productsRow?.is_over_allocated, 'active': productsRow.isStatusExpanded}"
                                          [attr.aria-expanded]="productsRow.isStatusExpanded"
                                          aria-controls="collapse_status"
                                          (click)="toggleStatusIcon(productsRow)" [tooltip]="'Product Status'"
                                          [placement]="'top'" container="body">
                                        {{ productsRow.status_quote_product?.name }}
                                    </span>
                                } @else if (modelOrder?.is_split_delivery && !modelOrder?.is_split_production && productsRow.status_quote_product && productsRow.status_quote_product?.name) {
                                    <span [class]="toKebabCase(productsRow.status_quote_product?.name)"
                                          class="status-flag"
                                          [ngClass]="{'mb-2': productsRow?.is_over_allocated, 'active': productsRow.isStatusExpanded}"
                                          [attr.aria-expanded]="productsRow.isStatusExpanded"
                                          aria-controls="collapse_status"
                                          (click)="toggleStatusIcon(productsRow)" [tooltip]="'Product Status '"
                                          [placement]="'top'" container="body">
                                        {{ productsRow.status_quote_product?.name }}
                                    </span>
                                } @else {
                                    @if (productsRow.stock_available == true) {
                                        <span class="status-flag available-at-warehouse"
                                              [ngClass]="{'mb-2': productsRow?.is_over_allocated, 'active': productsRow.isStatusExpanded}"
                                              [attr.aria-expanded]="productsRow.isStatusExpanded"
                                              aria-controls="collapse_status"
                                              (click)="toggleStatusIcon(productsRow)" [tooltip]="'Product Status '"
                                              [placement]="'top'" container="body" style="cursor: pointer;">
                                            Available At Warehouse
                                        </span>
                                    } @else if (productsRow.container_id > 0 && productsRow.container?.status) {
                                        <span [class]="toKebabCase(productsRow.container?.status?.name)"
                                              class="status-flag"
                                              [ngClass]="{'mb-2': productsRow?.is_over_allocated, 'active': productsRow.isStatusExpanded}"
                                              [attr.aria-expanded]="productsRow.isStatusExpanded"
                                              aria-controls="collapse_status"
                                              (click)="toggleStatusIcon(productsRow)" [tooltip]="'Product Status '"
                                              [placement]="'top'" container="body" style="cursor: pointer;">
                                            {{ productsRow.container?.status?.name }}
                                        </span>
                                    } @else if (!(productsRow.container_id > 0 || productsRow.stock_available == true) &&
                                        !productsRow?.product?.is_custom_product) {
                                        <span class="status-flag status-unassigned"
                                              [ngClass]="{'mb-2': productsRow?.is_over_allocated, 'active': productsRow.isStatusExpanded}"
                                              [attr.aria-expanded]="productsRow.isStatusExpanded"
                                              aria-controls="collapse_status"
                                              (click)="toggleStatusIcon(productsRow)" [tooltip]="'Product Status '"
                                              [placement]="'top'" container="body" style="cursor: pointer;">
                                            Unassigned
                                        </span>
                                    } @else {
                                        -
                                    }
                                }
                                @if (productsRow?.is_over_allocated) {
                                    <br>
                                    <span class="status over-allocated-status pulse-effect">Overallocated</span>
                                }
                                @if (productsRow.status_quote_product?.short_name ===
                                constants.ORDER_DELIVERY_OUT_TO_TENDER_SHORT) {
                                    <div class="approval-action">
                                        <button type="button" class="icon-btn accept-btn"
                                                (click)="acceptJob(productsRow.id, productsRow.quote_schedule_delivery_product?.quote_schedule_delivery_id)">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M1 9C1 11.1217 1.84285 13.1566 3.34315 14.6569C4.84344 16.1571 6.87827 17 9 17C11.1217 17 13.1566 16.1571 14.6569 14.6569C16.1571 13.1566 17 11.1217 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1C6.87827 1 4.84344 1.84285 3.34315 3.34315C1.84285 4.84344 1 6.87827 1 9Z"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round"/>
                                                <path d="M13 5.79883L7.7689 12.1988L5 8.99883" stroke="white"
                                                      stroke-width="1.5"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </button>
                                        <button type="button" class="icon-btn decline-btn"
                                                (click)="declineJob(productsRow.id, productsRow.quote_schedule_delivery_product?.quote_schedule_delivery_id)">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M1 9C1 11.1217 1.84285 13.1566 3.34315 14.6569C4.84344 16.1571 6.87827 17 9 17C11.1217 17 13.1566 16.1571 14.6569 14.6569C16.1571 13.1566 17 11.1217 17 9C17 6.87827 16.1571 4.84344 14.6569 3.34315C13.1566 1.84285 11.1217 1 9 1C6.87827 1 4.84344 1.84285 3.34315 3.34315C1.84285 4.84344 1 6.87827 1 9Z"
                                                    stroke="white" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round"/>
                                                <path d="M6 12L11.9996 6" stroke="white" stroke-width="1.5"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 12L6.00039 6" stroke="white" stroke-width="1.5"
                                                      stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </button>
                                    </div>
                                }
                            </td>
                        }

                        @if (modelOrder?.is_split_production && isOrderDetail) {
                            <td>
                                @if (productsRow?.stock_available) {
                                    <span> In Stock </span>
                                } @else if (productsRow?.container) {
                                    <span> {{
                                            productsRow?.container?.anticipated_warehouse_arrival_date ?
                                                (productsRow.container.anticipated_warehouse_arrival_date | date : 'dd/MM/yyyy') : '-'
                                        }} </span>
                                } @else {
                                    <span class="lead-time-tbc">
                                TBC <img src="/assets/admin/images/info-circle-icon.svg" width="20" height="20"
                                         alt="info-icon" class="info-icon"
                                         [tooltip]="'Please contact our sales team for clarification of the ETA to this item.'"/>
                            </span>
                                }
                            </td>
                        }
                        <td>
                            <div class="pro-qty-box">
                                @if (isPreview || isOfflineOrder || isOrderDeliveryStage()) {
                                    {{ productsRow?.quantity }}
                                    <!--                  @if (productsRow?.consumables_prices?.type && (productsRow?.consumables_prices?.type === constants.CONSUMABLE_QUANTITY_TYPE_DEFENDER || productsRow?.consumables_prices?.type === constants.CONSUMABLE_QUANTITY_TYPE_GOLD)) {-->
                                        <!--                    L-->
                                        <!--                  } @else if (productsRow?.consumables_prices?.type && productsRow?.consumables_prices?.type === constants.CONSUMABLE_QUANTITY_TYPE_LATICRETE_ADHESIVE) {-->
                                        <!--                    x 20kg bags-->
                                        <!--                  }-->
                                } @else {
                                    <div class="pro-qty">
                                        <button class="btn" [disabled]="isConsumableMinusDisabled(productsRow)"
                                                (click)="checkQuantity(productsRow, 'decrement')">
                                            <img src="/assets/admin/images/small-minus-icon.svg" width="12" height="2" alt="small-minus-icon"/>
                                        </button>
                                        <input #enteredQuantity type="text" autocomplete="off" value="{{ productsRow?.quantity }}" (keypress)="checkDecimalDot($event)" pattern="[0-9]+" maxlength="10" appDecimalInput="4" (input)="checkQuantityOnKeyPress(productsRow, 'text', enteredQuantity.value)">
                                        <button class="btn" (click)="checkQuantity(productsRow, 'increment')">
                                            <img src="/assets/admin/images/small-plus-icon.svg" width="12" height="12" alt="small-plus-icon"/>
                                        </button>
                                    </div>
                                }
                                <!-- A consumable has no product and so no unit of measurement: label it
                                     by what it is packed in rather than leaving the cell blank. -->
                                {{ productsRow?.consumable_id
                                    ? consumableUnitLabel(productsRow)
                                    : productsRow?.product?.unit_of_measurement?.name }}
                            </div>

                            @if (!(isPreview || isOfflineOrder || isOrderDeliveryStage())) {
                                @if (!productsRow?.product?.is_custom_product && !productsRow?.consumable_id &&
                                !productsRow?.hideMessage) {
                                    @if (+productsRow?.quantity > 0 && !(+productsRow?.quantity < +productsRow.product?.moq &&
                                        +productsRow.product?.moq > 0) && +productsRow.product?.moi > 0 &&
                                    calculateModulo(+productsRow?.quantity, +productsRow.product?.moi) != 0 && !isPreview &&
                                    !isOfflineOrder) {
                                        <div class="pro-prefer-qty">
                                            @if (+productsRow.clickesQuantity != +productsRow?.quantity &&
                                            !isDisabledQuoteDetail && (productsRow?.product?.is_sale == constants.IS_NO ||
                                                (productsRow?.product?.is_sale == constants.IS_YES && +productsRow?.quantity <
                                                    +productsRow?.product?.ul_available_qty))) {
                                                <div class="pro-prefer-qty-inner">
                                                    Prefer quantity
                                                    is {{ productsRow.clickesQuantity }} {{
                                                        productsRow.product?.unit_of_measurement?.name
                                                    }}
                                                    for the
                                                    selected product, <span
                                                    (click)="checkQuantity(productsRow, 'click')">Click
                                            Here</span>
                                                    to apply
                                                    it.
                                                </div>
                                            }
                                        </div>
                                    }
                                }
                            }
                        </td>

                        <td class="text-right">
                            {{ (productsRow?.rrp_price ? productsRow.rrp_price : 0) | currency : 'USD' : 'symbol' : '1.2-4' }}
                        </td>

                        <td class="text-right">
                            <div class="sale-text">
                                <img class="sale-icon" *ngIf="productsRow?.product?.is_sale == constants.IS_YES"
                                     [src]="constants.S3_PRODUCT_IMAGES_IMAGE_KIT_URL + '/ASSETS/GENERAL/ICONS/sale.svg'"
                                     width="30"
                                     height="30" alt="Sale Icon"/>
                                {{ +productsRow?.price | currency : 'USD' : 'symbol' : '1.2-4' }}
                            </div>
                        </td>
                        <td class="text-right edit-discount-field">
        <span class="edit-discount-text"
              (click)="!isPreview && !isOfflineOrder && openPopover(editDiscount, productsRow?.status_quote_product)">
            {{ (productsRow.discount != null ? productsRow.discount : 0) | number : '1.2-4' }}%
        </span>
                            <span [ngbPopover]="discountContent" [autoClose]="'outside'" #editDiscount="ngbPopover"
                                  [popoverTitle]="discountTitle" (hidden)="onPopoverHidden(productsRow)"
                                  placement="bottom"></span>

                            <ng-template #discountTitle>
                                <img src="/assets/admin/images/pen-edit-small-icon.svg" height="16" width="16"
                                     alt="Edit"/>
                                Edit Discount
                                <span class="close-btn" (click)="closePopOver(editDiscount,'',productsRow)">
                <img src="/assets/admin/images/close-icon.svg" height="16" width="16" alt="close-icon" title="Close"/>
            </span>
                            </ng-template>

                            <ng-template #discountContent>
                                <!-- Percentage input group -->
                                <div class="form-group">
                                    <label>Percentage:</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">%</span>
                                        </div>
                                        <input class="form-control" name="product_price" id="product_price"
                                               placeHolder="Enter Percentage"
                                               [ngModelOptions]="{ standalone: true }"
                                               (keypress)="checkDecimalDot($event)" pattern="[0-9]+"
                                               appDecimalInput="4" [(ngModel)]="productsRow.applied_discount"
                                               (change)="editProductDiscount($event, productsRow)"/>
                                    </div>
                                </div>

                                <!-- Discounted Price input group -->
                                <div class="form-group">
                                    <label>Discounted Price:</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">$</span>
                                        </div>
                                        <input class="form-control" name="product_price" id="product_price" type="text"
                                               placeHolder="Enter Price" [ngModelOptions]="{ standalone: true }"
                                               [(ngModel)]="productsRow.updated_sku_price"
                                               (keypress)="checkDecimalDot($event)"
                                               pattern="[0-9]+" (change)="editProductPrice($event, productsRow)"
                                               appCurrencyInput
                                               [decimalPlaces]="4"/>
                                    </div>
                                </div>

                                <!-- Update button -->
                                <div class="popover-action">
                                    <button type="button" class="btn"
                                            (click)="updateProductPriceDiscount(editDiscount, productsRow)">
                                        Update
                                    </button>
                                </div>
                            </ng-template>

                            <ng-template #discountTitle>
                                <div class="pop-header-main-price">
                                    <div class="text-left pop-title-left">
                                        <i><img src="{{constants.S3_BUCKET_URL}}/ic_edit_meeting.svg"
                                                (error)="helperFunction.getErrorImage($event)"/></i>
                                        Edit Discount
                                    </div>
                                    <div class="text-right pop-title-right">
                    <span (click)="closePopOver(editDiscount,'',productsRow)">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </span>
                </div>
            </div>
        </ng-template>
        <ng-template #discountContent>
            <div class="popover-body-inner custom-applied-discount">
                <div class="input-group">
                    <label class="grey-label" for="">Percentage:</label>
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">%</span>
                    </div>
                    <input class="form-control" name="product_price" id="product_price" type="text"
                        placeHolder="Enter Percentage" [ngModelOptions]="{ standalone: true }"
                        (keypress)="checkDecimalDot($event)" pattern="[0-9]+" appDecimalInput="4"
                        [(ngModel)]="productsRow.applied_discount"
                        (change)="editProductDiscount($event, productsRow)" />
                </div>
                <div class="input-group">
                    <label class="grey-label" for="">Discounted Price:</label>
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">$</span>
                    </div>
                    <input class="form-control" name="product_price" id="product_price" type="text"
                        placeHolder="Enter Price" [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="productsRow.updated_sku_price" (keypress)="checkDecimalDot($event)"
                        pattern="[0-9]+" (change)="editProductPrice($event, productsRow)" appCurrencyInput
                        [decimalPlaces]="4" />
                </div>
            </div>
            <div class="pop-footer text-center">
                <button type="button" class="submit-btn-grey"
                    (click)="updateProductPriceDiscount(editDiscount, productsRow)">Update
                </button>
            </div>
        </ng-template>
    </td>
    <td class="text-right">
        {{
        (productsRow?.discounted_price ? productsRow?.discounted_price : 0) | currency : 'USD' :
        'symbol' : '1.2-4'
        }}
    </td>
    <td class="text-right">
        {{ (productsRow?.final_total ? productsRow?.final_total : 0) | currency : "USD" : "symbol" }}
    </td>
    <td class="action-cells">
        <div class="pro-table-action">
            @if (!isPreview && (modelOrder?.is_split_delivery || modelOrder?.is_split_production) && isOrderDetail) {
            <button type="button" class="btn active" [ngClass]="{'active': productsRow.isStatusExpanded}"
                [attr.aria-expanded]="productsRow.isStatusExpanded" aria-controls="collapse_status"
                (click)="toggleStatusIcon(productsRow)" [tooltip]="'Product Status '" [placement]="'top'"
                container="body">
                <img src="/assets/admin/images/timer-icon.svg" width="22" height="22" alt="timer-icon" />
            </button>
            }
            <button type="button" class="btn" [tooltip]="HtmlContent" [placement]="'left'" container="body"
                containerClass="comment-tooltip" [ngClass]="{'added-comment': productsRow.note && productsRow.note.trim() !== '',
                                       'active': productsRow.isCommentExpanded}"
                [attr.aria-expanded]="productsRow.isCommentExpanded" (click)="toggleCommentIcon(productsRow)"
                aria-controls="collapse_comment">
                <img src="/assets/admin/images/comment-icon.svg" width="22" height="22" class="comment-icon"
                    alt="comment-icon">
                <img src="/assets/admin/images/comment-fill-icon.svg" width="22" height="22" class="comment-fill-icon"
                    alt="comment-fill-icon">
            </button>
            @if (!isPreview && !modelOrder?.is_consumable_order
            && (!modelOrder?.deliveryDespatchedHistory && !productsRow.deliveryDespatchedHistory)
            && (modelOrder?.type == constants.ORDER_TYPE_ORDER_SHORT || isQuoteDetail)) {
            <button type="button" class="btn" [ngClass]="{'active': productsRow.isStockExpanded}"
                [attr.aria-expanded]="productsRow.isStockExpanded" aria-controls="collapse_stock"
                (click)="toggleStockIcon(productsRow)" [tooltip]="'Stock Allocation'" [placement]="'top'"
                container="body">
                <img src="/assets/admin/images/stock-icon.svg" width="20" height="22" alt="stock-icon" />
            </button>
            }
            <ng-template #HtmlContent>
                <div [innerHtml]="getCommentTooltip(productsRow.note)" class="comment-tooltip-content"></div>
            </ng-template>
            @if (!isPreview && !isOfflineOrder && !isOrderProductDeliveryStage(productsRow)) {
            <button type="button" class="btn delete-product-btn" (click)="removeProduct(productsRow)"
                [tooltip]="'Delete Product'" [placement]="'top'" container="body">
                <img src="{{ s3BucketImageURL }}/delete-icon.svg" (error)="helperFunction.getErrorImage($event)"
                    width="22" height="22" alt="comment-icon" />
            </button>
            }
            <!-- One merge control per split line. It opens the destination picker; there is no
                 implicit merge-into-the-parent, the admin always chooses the line to merge into.
                 A line that was itself split again can still be merged — its own split stock
                 follows it across to the chosen destination. -->
            @if (!isPreview && productsRow?.parent_id && !productsRow?.consumables_prices && !isOrderProductDeliveryStage(productsRow)) {
            <button type="button" class="btn" (click)="openRevertSplitModal(productsRow)"
                [tooltip]="'Merge Split'" [placement]="'top'" container="body">
                <img src="assets/admin/images/merge.svg" alt="Merge Split" style="width: 18px; height: 18px;">

            </button>
            }
        </div>
    </td>
    <!--@if (productsRow?.product?.is_deleted && !isOfflineOrder) {
                            <td class="d-none p-0">
                                <div class="product-not-available"
                                     [class.product-table-watermark-adhesive]="productsRow?.product?.is_deleted && !isOfflineOrder && !productsRow?.disabledAdhesivePrice"
                                     [class.product-table-watermark-sealer]="productsRow?.product?.is_deleted && !isOfflineOrder && (!productsRow?.disabledSealerPriceDefender || !productsRow?.disabledSealerPriceGold)">
                                    <h4>Product no longer available.</h4>
                                    <p>To proceed with order, kindly remove this item from your quote.</p>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #discountContent>
                                <div class="popover-body-inner custom-applied-discount">
                                    <div class="input-group">
                                        <label class="grey-label" for="">Percentage:</label>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">%</span>
                                        </div>
                                        <input class="form-control" name="product_price" id="product_price" type="text"
                                               placeHolder="Enter Percentage" [ngModelOptions]="{ standalone: true }"
                                               (keypress)="checkDecimalDot($event)" pattern="[0-9]+" appDecimalInput
                                               [(ngModel)]="productsRow.applied_discount"
                                               (change)="editProductDiscount($event, productsRow)"/>
                                    </div>
                                    <div class="input-group">
                                        <label class="grey-label" for="">Discounted Price:</label>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">$</span>
                                        </div>
                                        <input class="form-control" name="product_price" id="product_price" type="text"
                                               placeHolder="Enter Price" [ngModelOptions]="{ standalone: true }"
                                               [(ngModel)]="productsRow.updated_sku_price"
                                               (keypress)="checkDecimalDot($event)"
                                               pattern="[0-9]+" (change)="editProductPrice($event, productsRow)"
                                               appCurrencyInput
                                               [decimalPlaces]="4"/>
                                    </div>
                                </div>
                                <div class="pop-footer text-center">
                                    <button type="button" class="submit-btn-grey"
                                            (click)="updateProductPriceDiscount(editDiscount, productsRow)">Update
                                    </button>
                                </div>
                            </ng-template>
                        </td>
                        <td class="text-right">
                            {{
                                (productsRow?.discounted_price ? productsRow?.discounted_price : 0) | currency : "USD" :
                                    "symbol"
                            }}
                        </td>
                        <td class="text-right">
                            {{ (productsRow?.final_total ? productsRow?.final_total : 0) | currency : "USD" : "symbol" }}
                        </td>
                        <td class="action-cells">
                            <div class="pro-table-action">
                                @if (!isPreview && (modelOrder?.is_split_delivery || modelOrder?.is_split_production) && isOrderDetail) {
                                    <button type="button" class="btn active"
                                            [ngClass]="{'active': productsRow.isStatusExpanded}"
                                            [attr.aria-expanded]="productsRow.isStatusExpanded"
                                            aria-controls="collapse_status"
                                            (click)="toggleStatusIcon(productsRow)" [tooltip]="'Product Status '"
                                            [placement]="'top'"
                                            container="body">
                                        <img src="/assets/admin/images/timer-icon.svg" width="22" height="22"
                                             alt="timer-icon"/>
                                    </button>
                                }
                                @if (!isOrderCancel && !isQuoteCancel) {
                                    <button type="button" class="btn" [tooltip]="HtmlContent" [placement]="'left'"
                                            container="body"
                                            containerClass="comment-tooltip" [ngClass]="{'added-comment': productsRow.note && productsRow.note.trim() !== '',
                                           'active': productsRow.isCommentExpanded}"
                                            [attr.aria-expanded]="productsRow.isCommentExpanded"
                                            (click)="toggleCommentIcon(productsRow)"
                                            aria-controls="collapse_comment">
                                        <img src="/assets/admin/images/comment-icon.svg" width="22" height="22"
                                             class="comment-icon"
                                             alt="comment-icon">
                                        <img src="/assets/admin/images/comment-fill-icon.svg" width="22" height="22"
                                             class="comment-fill-icon"
                                             alt="comment-fill-icon">
                                    </button>
                                }
                                @if (!isPreview && !modelOrder?.is_consumable_order
                                && (!modelOrder?.deliveryDespatchedHistory && !productsRow.deliveryDespatchedHistory)
                                && (modelOrder?.type == constants.ORDER_TYPE_ORDER_SHORT || isQuoteDetail)) {
                                    <button type="button" class="btn"
                                            [ngClass]="{'active': productsRow.isStockExpanded}"
                                            [attr.aria-expanded]="productsRow.isStockExpanded"
                                            aria-controls="collapse_stock"
                                            (click)="toggleStockIcon(productsRow)" [tooltip]="'Stock Allocation'"
                                            [placement]="'top'"
                                            container="body">
                                        <img src="/assets/admin/images/stock-icon.svg" width="20" height="22"
                                             alt="stock-icon"/>
                                    </button>
                                }
                                <ng-template #HtmlContent>
                                    <div [innerHtml]="getCommentTooltip(productsRow.note)"
                                         class="comment-tooltip-content"></div>
                                </ng-template>
                                @if (!isPreview && !isOfflineOrder && !isOrderProductDeliveryStage(productsRow)) {
                                    <button type="button" class="btn delete-product-btn"
                                            (click)="removeProduct(productsRow)"
                                            [tooltip]="'Delete Product'" [placement]="'top'" container="body">
                                        <img src="{{ s3BucketImageURL }}/delete-icon.svg"
                                             (error)="helperFunction.getErrorImage($event)"
                                             width="22" height="22" alt="comment-icon"/>
                                    </button>
                                }
                            </div>
                        </td>
                        @if (productsRow?.product?.is_deleted && !isOfflineOrder) {
                                                <td class="d-none p-0">
                                                    <div class="product-not-available"
                                                         [class.product-table-watermark-adhesive]="productsRow?.product?.is_deleted && !isOfflineOrder && !productsRow?.disabledAdhesivePrice"
                                                         [class.product-table-watermark-sealer]="productsRow?.product?.is_deleted && !isOfflineOrder && (!productsRow?.disabledSealerPriceDefender || !productsRow?.disabledSealerPriceGold)">
                                                        <h4>Product no longer available.</h4>
                                                        <p>To proceed with order, kindly remove this item from your quote.</p>
                                                    </div>
                                                </td>
                                            }-->
                    </tr>
                        @if (isOrderDetail && productsRow.isStatusExpanded && !isPreview && (modelOrder?.is_split_delivery ||
                            modelOrder?.is_split_production)) {
                            <tr>
                                <td colspan="14" id="collapse_status">
                                    <div [ngbCollapse]="!productsRow.isStatusExpanded">
                                        <app-milestones-status [type]="constants.QUOTE_PRODUCT_TYPE"
                                                               [orderId]="modelOrder?.id"
                                                               [modelQuoteProduct]="{container: productsRow.container,warehouseArrivalDateHistories: productsRow.warehouseArrivalDateHistories}"
                                                               [quoteProductId]="productsRow.id"
                                                               [currentStatusId]="productsRow.status_id"
                                                               (ChangeStatusEvent)="openChangeStatusPopup($event, productsRow)"
                                                               [modelOrder]="{
                                                                quote_product: modelOrder.quote_product,
                                                                is_split_production: modelOrder.is_split_production,
                                                                is_split_delivery: modelOrder.is_split_delivery,
                                                                stock_required_date: modelOrder.stock_required_date,
                                                                status: modelOrder.status,
                                                                is_consumable_order: modelOrder.is_consumable_order,
                                                                warehouseArrivalDateHistories: modelOrder.warehouseArrivalDateHistories,
                                                                }"
                                                               [quoteProductStatus]="productsRow?.status_quote_product"
                                                               [stockRequiredDateFromDesptch]="productsRow?.quote_schedule_delivery_product?.stock_required_date"></app-milestones-status>
                                    </div>
                                </td>
                            </tr>
                        }
                    <tr>
                        <td colspan="14" [id]="'collapse_comment_' + productsRow.id" class="pt-0 pb-0 conditions-details">
                            <div [ngbCollapse]="!productsRow.isCommentExpanded">
                                <div class="collapse-content">
                                    <div class="editor-container" #editorContainer [id]="productsRow.id"
                                         data-id="{{ productsRow.id }}">
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                        @if ((modelOrder?.type == constants.ORDER_TYPE_ORDER_SHORT || isQuoteDetail) && productsRow.isStockExpanded &&
                        (!modelOrder?.deliveryDespatchedHistory && !productsRow.deliveryDespatchedHistory)) {
                            <tr>
                                <td colspan="14" id="collapse_stock" class="pt-5px">
                                    <div [ngbCollapse]="!productsRow.isStockExpanded">
                                        <!--
                                          Assembled products (PDF section 4.1): no stock of their own,
                                          so show a roll-up summary and then the SAME familiar card
                                          layout once per COMPONENT SKU. Falls back to the normal
                                          cards whenever the breakdown is unavailable.
                                        -->
                                        @if (productsRow?.product?.is_assembled_product) {
                                        <!-- Opens with the line, not after the component rows: the card set shows its own
                                             skeleton while it loads, so the panel is never blank. -->
                                        @if (productsRow?.componentAllocation?.unitBoardInput) {
                                            <!--
                                              The component's own Stock Allocation cards: the SAME component the ordinary product path
                                              renders in the @else below, put into component mode. Unassigned Stock / Stock On Hand /
                                              one card per container, dragged exactly as for any other product. Nothing here is
                                              assembled-specific except which rows it is given and what a drop writes — see
                                              StockAllocationContentComponent.componentAllocation.

                                              It renders BELOW the parent/child table rather than inside a cell of it: the cards draw
                                              their own tables, and nesting those in a <td> collapsed the column widths and let this
                                              page's sticky <thead> rule float over them.
                                            -->
                                            <!-- The container Edit and "+ Add New Container" buttons on these cards reach the
                                                 page through the same three outputs as the ordinary cards below. Without them
                                                 the click fetched the container and nothing listened, so the form never opened. -->
                                            <div class="alloc-open-panel w-100">
                                                <!--
                                                  The three container-sidebar outputs are relayed here exactly as in the
                                                  ordinary-product branch below. Without them a container card's Edit
                                                  button emitted into nothing: the card is rendered, the button is
                                                  enabled, the click fetches the container — and then the sidebar never
                                                  opens, because no one is listening. Every order carrying an assembled
                                                  product took that path.
                                                -->
                                                <app-stock-allocation-content class="w-100"
                                                                              [assembledUnitBoard]="productsRow?.componentAllocation?.unitBoardInput"
                                                                              [isProductTable]="true"
                                                                              [isReadOnly]="isQuoteDetail"
                                                                              [disableDragAndDropBasedOnOrder]="disableDragAndDropBasedOnOrder"
                                                                              [disableDragAndDrop]="productsRow.disableDragAndDrop"
                                                                              (containerSidebarClickEvent)="containerSidebarClickEvent.emit(true)"
                                                                              (selectedContainerEvent)="selectedContainerEvent.emit($event)"
                                                                              (selectedProductAddContainerEvent)="selectedProductAddContainerEvent.emit($event)"
                                                                              [activeTab]="1" [activeIndex]="i"
                                                                              [orderId]="modelOrder?.id"
                                                                              [exportId]="modelOrder?.export_id"
                                                                              (containerSidebarClickEvent)="containerSidebarClickEvent.emit(true)"
                                                                              (selectedContainerEvent)="selectedContainerEvent.emit($event)"
                                                                              (selectedProductAddContainerEvent)="selectedProductAddContainerEvent.emit($event)"
                                                                              (dropActionCompleted)="onComponentAllocationChanged(productsRow, $event)"
                                                                              [frontendUserId]="modelOrder?.frontend_user_id"></app-stock-allocation-content>
                                            </div>
                                        }
                                        } @else {
                                            <app-stock-allocation-content class="w-100" [productId]="productsRow.product_id"
                                                                          [isProductTable]="true"
                                                                          [isReadOnly]="isQuoteDetail"
                                                                          [disableDragAndDropBasedOnOrder]="disableDragAndDropBasedOnOrder"
                                                                          [disableDragAndDrop]="productsRow.disableDragAndDrop"
                                                                          (containerSidebarClickEvent)="containerSidebarClickEvent.emit(true)"
                                                                          (selectedContainerEvent)="selectedContainerEvent.emit($event)"
                                                                          [activeTab]="1" [activeIndex]="i"
                                                                          (selectedProductAddContainerEvent)="selectedProductAddContainerEvent.emit($event)"
                                                                          [orderId]="modelOrder?.id"
                                                                          [exportId]="modelOrder?.export_id"
                                                                          [uom]="productsRow?.product?.unit_of_measurement?.name"
                                                                          [stock_available]="productsRow?.stock_available"
                                                                          [containerId]="productsRow?.container_id"
                                                                          [lineContainer]="productsRow?.frozen_dates_container_id === productsRow?.container_id ? productsRow?.container : null"
                                                                          [orderFrozenContainers]="frozenOrderContainers"
                                                                          (dropActionCompleted)="handleDropActionCompleted($event, productsRow)"
                                                                          [frontendUserId]="modelOrder?.frontend_user_id"></app-stock-allocation-content>
                                        }
                                    </div>
                                </td>
                            </tr>
                        }

                        @if ((
                            (isPreview && hasSelectedAdhesiveCalculator(productsRow) && !isOfflineConsumableDisplay) ||
                            (!isPreview && isOrderDetail && !isOfflineConsumableDisplay) ||
                            (!isPreview && isQuoteDetail) ||
                            (!isPreview && !isQuoteDetail && !isOrderDetail && !isOfflineConsumableDisplay && productsRow?.quoteProductCalculators?.length)
                            ||
                            (isOfflineConsumableDisplay && shouldDisplayAdhesiveOrSealerCalculator(productsRow,
                                [constants.CONSUMABLE_CALCULATOR_TYPE_ADHESIVE]))
                        )) {
                            @if (productsRow?.quoteProductCalculators?.length &&
                            !productsRow?.disabledAdhesivePrice &&
                            (productsRow?.product?.type !== constants.PRODUCT_TYPE_SURFACE_ACCESSORY ||
                                productsRow?.product?.is_custom_product)) {

                                <tr class="pro-title-td">
                                    <td colspan="10">Premium Adhesive</td>
                                </tr>

                                @for (calculator of productsRow.quoteProductCalculators; track calculator.type; let j = $index) {
                                    @if (calculator.type === constants.CONSUMABLE_CALCULATOR_TYPE_ADHESIVE && calculator.total_unit > 0) {
                                        <tr class="pro-info-td">
                                            @if (!isPreview && !isOfflineConsumableDisplay) {
                                                <td>
                                                    <label class="checkbox-item">
                                                        <input type="checkbox" data-md-icheck
                                                               [checked]="calculator?.is_selected"
                                                               [disabled]="modelOrder?.is_archive || modelOrder?.is_expired || isDisabledQuoteDetail || isSyncingWithUnleashed || (modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || modelOrder?.status?.short_name === constants.ORDER_FOLLOW_UP_SHORT || productsRow?.status_quote_product?.short_name === constants.ORDER_DELIVERD_SHORT)"
                                                               [ngClass]="{ 'cursor-not-allowed': modelOrder?.is_archive || modelOrder?.is_expired || isDisabledQuoteDetail || isSyncingWithUnleashed || (modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || modelOrder?.status?.short_name === constants.ORDER_FOLLOW_UP_SHORT || productsRow?.status_quote_product?.short_name === constants.ORDER_DELIVERD_SHORT) }"
                                                               (change)="toggleProductCalculator($event, productsRow, j, i, constants.CONSUMABLE_CALCULATOR_TYPE_ADHESIVE)"/>
                                                        <span class="checkmark"></span>
                                                    </label>
                                                </td>
                                            }
                                            <td [attr.colspan]="2
    + (modelOrder?.is_split_delivery ? 1 : 0)
    + (((modelOrder?.is_split_delivery || modelOrder?.is_split_production) && isOrderDetail) ? 1 : 0)
    + ((modelOrder?.is_split_production && isOrderDetail) ? 1 : 0)
    + ((isPreview || isOfflineConsumableDisplay) ? 1 : 0)">
                                                <!--                        (productsRow?.product?.is_custom_product ? 3 : 2)-->
                                                {{ constants.CONSUMABLE_CALCULATOR_CONSTANTS.TYPE_ADHESIVE }}
                                            </td>

                                            <td>{{ calculator.total_unit || 0 }} X 20kg bags</td>

                                            <td class="text-right">
                                                {{ calculatePrice(calculator.total_price) | currency: 'USD':'symbol' }}
                                            </td>
                                            <td class="text-right">
                                                @if (isOfflineConsumableDisplay) {
                                                    {{ calculatePrice(calculator.trade_price) | currency: 'USD':'symbol' }}
                                                } @else {
                                                    {{ calculatePrice(calculator.total_price) | currency: 'USD':'symbol' }}
                                                }
                                            </td>

                                            <td class="text-right">
                                                @if (isOfflineConsumableDisplay) {
                                                    {{ calculator.discount ? calculator.discount : 0 | number: '1.2-2' }}%
                                                } @else {
                                                    0.00%
                                                }
                                            </td>
                                            <td class="text-right">
                                                @if (isOfflineConsumableDisplay) {
                                                    {{ calculator.discounted_price || 0 | currency: 'USD':'symbol' }}
                                                } @else {
                                                    {{ calculator.total_price || 0 | currency: 'USD':'symbol' }}
                                                }
                                            </td>
                                            <td class="text-right">
                                                @if (isOfflineConsumableDisplay) {
                                                    {{ calculator.discounted_price || 0 | currency: 'USD':'symbol' }}
                                                } @else {
                                                    {{ calculator.total_price || 0 | currency: 'USD':'symbol' }}
                                                }
                                            </td>
                                            <td>
                                            </td>
                                        </tr>
                                    }
                                }
                            }
                        }

                        @if ((isPreview && hasSelectedPremiumSealerCalculator(productsRow) && !isOfflineConsumableDisplay) ||
                        (!isPreview && isQuoteDetail) ||
                        (!isPreview && isOrderDetail && !isOfflineConsumableDisplay) ||
                        (!isPreview && !isQuoteDetail && !isOrderDetail && !isOfflineConsumableDisplay && productsRow?.quoteProductCalculators?.length)
                        ||
                        (isOfflineConsumableDisplay && shouldDisplayAdhesiveOrSealerCalculator(productsRow,
                            [constants.CONSUMABLE_CALCULATOR_TYPE_DEFENDER, constants.CONSUMABLE_CALCULATOR_TYPE_GOLD]))) {
                            @if (((!productsRow?.disabledSealerPriceDefender || !productsRow?.disabledSealerPriceGold) &&
                                productsRow?.quoteProductCalculators?.length) || productsRow?.product?.is_custom_product) {

                                <tr class="pro-title-td">
                                    <td colspan="10">Premium Sealer</td>
                                </tr>

                                @for (calculator of productsRow.quoteProductCalculators; track 'calculator1-' + calculator.type; let j =
                                    $index) {
                                    @if ((calculator.type === constants.CONSUMABLE_CALCULATOR_TYPE_DEFENDER || calculator.type === constants.CONSUMABLE_CALCULATOR_TYPE_GOLD) && calculator.total_unit > 0) {
                                        @if ((!isPreview && !isOfflineConsumableDisplay) || (isPreview && calculator.is_selected) || (!isPreview && isOfflineConsumableDisplay && calculator.is_selected)) {
                                            <tr class="pro-info-td">
                                                @if (!isPreview && !isOfflineConsumableDisplay) {
                                                    <td>
                                                        <label class="checkbox-item">
                                                            <input type="checkbox" data-md-icheck
                                                                   [checked]="calculator?.is_selected"
                                                                   [disabled]="modelOrder?.is_archive || modelOrder?.is_expired || isDisabledQuoteDetail || isSyncingWithUnleashed || ((modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || modelOrder?.status?.short_name === constants.ORDER_FOLLOW_UP_SHORT || productsRow?.status_quote_product?.short_name === constants.ORDER_DELIVERD_SHORT))"
                                                                   [ngClass]="{ 'cursor-not-allowed': modelOrder?.is_archive || modelOrder?.is_expired || isDisabledQuoteDetail || isSyncingWithUnleashed || ((modelOrder?.status?.short_name === constants.ORDER_DELIVERD_SHORT || modelOrder?.status?.short_name === constants.ORDER_FOLLOW_UP_SHORT || productsRow?.status_quote_product?.short_name === constants.ORDER_DELIVERD_SHORT)) }"
                                                                   (change)="toggleProductCalculator($event, productsRow, j, i)"/>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </td>
                                                }
                                                <td [attr.colspan]="2
    + (modelOrder?.is_split_delivery ? 1 : 0)
    + (((modelOrder?.is_split_delivery || modelOrder?.is_split_production) && isOrderDetail) ? 1 : 0)
    + ((modelOrder?.is_split_production && isOrderDetail) ? 1 : 0)
    + ((isPreview || isOfflineConsumableDisplay) ? 1 : 0)">
                                                    <!--                          (productsRow?.product?.is_custom_product ? 3 : 2)-->
                                                    {{
                                                        calculator.type === constants.CONSUMABLE_CALCULATOR_TYPE_DEFENDER
                                                            ? constants.CONSUMABLE_CALCULATOR_CONSTANTS.TYPE_DEFENDER
                                                            : constants.CONSUMABLE_CALCULATOR_CONSTANTS.TYPE_GOLD
                                                    }}
                                                </td>

                                                <td>{{ calculator.total_unit || 0 }} L</td>

                                                <td class="text-right">
                                                    @if (isOfflineConsumableDisplay) {
                                                        {{ calculatePrice(calculator.total_price) | currency: 'USD':'symbol' }}
                                                    } @else {
                                                        {{ calculatePrice(calculator.total_price) | currency: 'USD':'symbol' }}
                                                    }
                                                </td>

                                                <td class="text-right">
                                                    @if (isOfflineConsumableDisplay) {
                                                        {{ calculatePrice(calculator.trade_price) | currency: 'USD':'symbol' }}
                                                    } @else {
                                                        {{ calculatePrice(calculator.total_price) | currency: 'USD':'symbol' }}
                                                    }
                                                </td>

                                                <td class="text-right">
                                                    @if (isOfflineConsumableDisplay) {
                                                        {{ calculator.discount ? calculator.discount : 0 | number: '1.2-4' }}%
                                                    } @else {
                                                        0.00%
                                                    }
                                                </td>

                                                <td class="text-right">
                                                    @if (isOfflineConsumableDisplay) {
                                                        {{ calculator.discounted_price || 0 | currency: 'USD':'symbol' }}
                                                    } @else {
                                                        {{ calculator.total_price || 0 | currency: 'USD':'symbol' }}
                                                    }
                                                </td>
                                                <td class="text-right">
                                                    @if (isOfflineConsumableDisplay) {
                                                        {{ calculator.discounted_price || 0 | currency: 'USD':'symbol' }}
                                                    } @else {
                                                        {{ calculator.total_price || 0 | currency: 'USD':'symbol' }}
                                                    }
                                                </td>
                                                <td class="text-right">
                                                </td>

                                            </tr>

                                        }
                                    }
                                }
                            }
                        }
                    </tbody>
                </ng-container>
            } @else {
                <tbody>
                <tr>
                    <td colspan="10" class="text-center">No records found</td>
                </tr>
                </tbody>
            }
        </table>
    </div>
</div>
